<style scoped>
td {
  /*border: 1px solid white;*/
}

.big {
  font-size: 18px;
}

.red {
  color:var(--color-danger-light);
}

.green {
  color: var(--color-success-light);
}

.headers-text {
  color: var(--color-text-dark);
}

/*.ivu-modal{*/
/*  top: 0;*/
/*}*/
</style>

<template>
  <Modal
    v-model="$store.state.confirmModal.show"
    class-name="vertical-center-modal1"
    :styles="{top: '10px', left: '65px'}"
    width="450"
  >
    <p
      slot="header"
      style="text-align:center"
    >
      <span style="font-size: 14px; color: var(--color-modal-title);">{{ $text.tr('ПОДТВЕРЖДЕНИЕ СДЕЛКИ') }}</span>
    </p>
    <div style="font-size: 14px;">
      <table width="100%">
        <tr>
          <td></td>
          <td
            class="big green"
            v-if="$store.state.trade.side === 'B'"
            width="70%"
          >{{ $text.tr('Покупка') }}</td>
          <td
            class="big red"
            v-if="$store.state.trade.side === 'S'"
            width="70%"
          >{{ $text.tr('Продажа') }}</td>
        </tr>
        <tr>
          <td class="headers-text">{{ $text.tr('КОЛ-ВО') }}</td>
          <td class="big">{{ $store.state.trade.qty }} {{ $store.state.trade.pair[0] }}</td>
        </tr>
        <tr>
          <td class="headers-text">{{ $text.tr('ЦЕНА') }}</td>
          <td
            class="big"
            v-if="$store.state.trade.type !== 'market'"
          >{{ $store.state.trade.price }} {{
              $store.state.trade.pair[1] }}
          </td>
          <td
            class="big"
            v-if="$store.state.trade.type === 'market'"
          >{{ $text.tr('По рынку') }}</td>
        </tr>
        <tr>
          <td class="headers-text">{{ $text.tr('СУММА') }}</td>
          <td class="big">{{ $store.state.trade.amount }} {{ $store.state.trade.pair[1] }}</td>
        </tr>
        <tr v-if="$store.getters.isFutures">
          <td class="headers-text">{{ $text.tr('ПЛЕЧО') }}</td>
          <td class="big">{{ $store.state.trade.leverage }}X</td>
        </tr>
        <tr>
          <td>
            <div style="height: 10px;"></div>
          </td>
        </tr>
        <tr v-if="parseFloat($store.state.trade.slprice) > 0">
          <td class="headers-text">STOP LOSS</td>
          <td class="big">{{ $store.state.trade.slprice }}
            <span
              v-if="$store.state.trade.type !== 'market'"
              class="red"
            >({{ profitPctCalc($store.state.trade.price, $store.state.trade.slprice) }}%)</span>
            <span v-if="parseFloat($store.state.trade.sltrail) > 0"> trail</span>
          </td>
        </tr>
        <tr v-if="parseFloat($store.state.trade.tpprice) > 0 && $store.state.trade.tpsteps.length < 1">
          <td class="headers-text">TAKE PROFIT</td>
          <td class="big">{{ $store.state.trade.tpprice }}
            <span
              v-if="$store.state.trade.type !== 'market'"
              class="green"
            >({{ profitPctCalc($store.state.trade.price, $store.state.trade.tpprice) }}%)</span>
            <span v-if="parseFloat($store.state.trade.tptrail) > 0"> trail {{ $store.state.trade.tptrail }}</span>
          </td>
        </tr>
        <tr v-if="$store.state.trade.tpsteps.length > 0">
          <td
            class="headers-text"
            style="vertical-align: top;"
          >TAKE PROFIT</td>
          <td class="big">
            <template v-for="(step, index) in $store.state.trade.tpsteps">
              <div :key="'st-' + index"> {{ step.Price }}
                <span
                  v-if="$store.state.trade.type !== 'market'"
                  class="green"
                >({{ profitPctCalc($store.state.trade.price, step.Price) }}%)</span>
                <span v-if="index === $store.state.trade.tpsteps.length - 1 && parseFloat($store.state.trade.tptrail) > 0"> trail {{ $store.state.trade.tptrail }}</span>
                - {{ step.Pct }}%
              </div>
            </template>
          </td>
        </tr>
        <tr>
          <td>
            <div style="height: 10px;"></div>
          </td>
        </tr>
        <tr>
          <td class="headers-text">{{ $text.tr('КОММЕНТАРИЙ') }}</td>
          <td class="big">
            <Input element-id="commentInput" v-model="comments" @on-keydown="onKeyDown" />
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer">
      <Button
        :loading="loading"
        :disabled="loading"
        @click="confirm"
        long
        size="large"
        style="font-size: 12px"
      >{{ $text.tr('ПОДТВЕРДИТЬ') }}</Button>
    </div>
  </Modal>
</template>

<script>
import Decimal from 'decimal.js'
import terminal from '@/services/terminal'

export default {
  name: 'ConfirmTradeModal',
  data () {
    return {
      loading: false,
      comments: ''
    }
  },
  watch: {
    '$store.state.confirmModal.show': function (value) {
      if (this.$store.state.confirmModal.show) {
        this.loading = false
      }

      if (value) {
        const commentInput = document.getElementById('commentInput')

        setTimeout(() => {
          commentInput.focus()
        }, 10)
      }
    }
  },
  methods: {
    onKeyDown (event) {
      if (event.keyCode === 13) {
        this.confirm()
      }
    },
    confirm () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.confirmTrade()
    },
    async confirmTrade () {
      this.$store.state.trade.comment = this.comments
      await terminal.ApiCreateTrade(this)
      this.comments = ''
      this.$store.state.confirmModal.show = false
      this.$store.state.trade.lastTrade = Date.now()
    },
    profitPctCalc (buy, sell) {
      return new Decimal(sell)
        .sub(buy)
        .mul(100)
        .div(buy)
        .toDP(1)
        .toString()
    }
  }
}
</script>
